import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Logo } from "./Logo";
import { TIER_LABEL } from "../lib/api";

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors duration-300 ${isActive ? "text-[#D7263D]" : "text-[#26355A] hover:text-[#D7263D]"}`;

function Links({ user, onNav }) {
  if (!user) {
    return (
      <>
        <a href="/#tiers" onClick={onNav} data-testid="nav-tiers-link" className="text-sm text-[#26355A] hover:text-[#D7263D] transition-colors">Membership</a>
        <NavLink to="/auth" onClick={onNav} data-testid="nav-login-btn" className={linkCls}>Sign in</NavLink>
      </>
    );
  }
  return (
    <>
      {user.role === "admin" && <NavLink to="/studio" onClick={onNav} data-testid="nav-admin-link" className={linkCls}>Studio</NavLink>}
      <NavLink to="/feed" onClick={onNav} data-testid="nav-feed-link" className={linkCls}>Feed</NavLink>
      {user.role !== "admin" && <NavLink to="/messages" onClick={onNav} data-testid="nav-dms-link" className={linkCls}>Messages</NavLink>}
      {user.role !== "admin" && <NavLink to={user.tier ? "/billing" : "/join"} onClick={onNav} data-testid="nav-membership-link" className={linkCls}>{user.tier ? "Billing" : "Choose tier"}</NavLink>}
    </>
  );
}

export function Nav() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const signOut = async () => {
    setOpen(false);
    await logout();
    navigate("/");
  };
  return (
    <header data-testid="site-nav" className="absolute top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#FFF8EE]/75 border-b border-[#0E1B3D]/[0.07]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-9">
          <Links user={user} />
          {user ? (
            <div className="flex items-center gap-4">
              {user.tier && <span data-testid="nav-tier-badge" className="font-mono-x text-[0.65rem] tracking-[0.2em] uppercase px-3 py-1.5 border border-[#D7263D]/40 text-[#D7263D]">{TIER_LABEL[user.tier]}</span>}
              <button data-testid="nav-logout-btn" onClick={signOut} className="text-[#26355A] hover:text-[#D7263D] transition-colors" aria-label="Sign out"><LogOut className="w-4 h-4" /></button>
            </div>
          ) : (
            <Link to="/auth?mode=signup" data-testid="nav-join-btn" className="gold-btn px-6 py-2.5 text-sm font-semibold tracking-wide">Join now</Link>
          )}
        </nav>
        <button data-testid="nav-mobile-toggle" className="md:hidden text-[#0E1B3D] p-2" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-[#0E1B3D]/10 bg-[#FFF8EE] px-6 py-6 flex flex-col gap-5">
          <Links user={user} onNav={() => setOpen(false)} />
          {user ? (
            <button data-testid="nav-mobile-logout-btn" onClick={signOut} className="text-left text-sm text-[#26355A]">Sign out</button>
          ) : (
            <Link to="/auth?mode=signup" onClick={() => setOpen(false)} data-testid="nav-mobile-join-btn" className="gold-btn px-6 py-3 text-sm font-semibold text-center">Join now</Link>
          )}
        </div>
      )}
    </header>
  );
}
